import React, { useEffect, useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../../Kryzen Alpha App/Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcClapperboard, FcCollaboration, FcEditImage, FcInspection } from "react-icons/fc";
import SimpleButton from "../../../Components/layouts/simple_button";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";

const ViewGraphics = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/graphics/view/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.data);
        } else {
          Toast("error", "Error while getting graphics!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);


  const linkifyText = (text) => {
    if (!text) return "N/A";

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return part;
    });
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcEditImage className="fs-2 me-1" />
                  Graphics
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h3 className="card-title">View Graphics</h3>
            </div>

            <div className="card-body">
              {!data ? (
                <div className="text-center text-muted">No data found</div>
              ) : (
                <>
                  {/* Branding */}
                  <div className="mb-3 row">
                    <label className="col-3 form-label">Branding</label>
                    <div className="col">{data?.postBranding || "N/A"}</div>
                  </div>

                  {/* Title */}
                  <div className="mb-3 row">
                    <label className="col-3 form-label">Title</label>
                    <div className="col">{data?.postTitle || "N/A"}</div>
                  </div>

                  {/* Headline */}
                  <div className="mb-3 row">
                    <label className="col-3 form-label">Headline</label>
                    <div className="col">{data?.postHeadline || "N/A"}</div>
                  </div>

                  {/* Subheading */}
                  <div className="mb-3 row">
                    <label className="col-3 form-label">Subheading</label>
                    <div className="col">{data?.postSubheading || "N/A"}</div>
                  </div>

                  {/* CTA */}
                  <div className="mb-3 row">
                    <label className="col-3 form-label">CTA</label>
                    <div className="col">{data?.postCta || "N/A"}</div>
                  </div>

                  {/* CTA Subheading */}
                  <div className="mb-3 row">
                    <label className="col-3 form-label">CTA Subheading</label>
                    <div className="col">{data?.ctaSubheading || "N/A"}</div>
                  </div>

                  {/* Description */}
                  <div className="mb-3 row">
                    <label className="col-3 form-label">Description</label>
                    <div className="col">{linkifyText(data?.postDescription || "N/A")}</div>
                  </div>

                  {/* Post Type */}
                  <div className="mb-3 row">
                    <label className="col-3 form-label">Post Type</label>
                    <div className="col">{data?.postType || "N/A"}</div>
                  </div>

                  {/* Platforms */}
                  <div className="mb-3 row">
                    <label className="col-3 form-label">Platforms</label>
                    <div className="col">
                      {data?.platforms?.length > 0
                        ? data.platforms.join(", ")
                        : "N/A"}
                    </div>
                  </div>
                      {/* Created At */}
                      <div className="mb-3 row">
                    <label className="col-3 form-label">Created At</label>
                    <div className="col">
                      {new Date(data.createdAt).toLocaleString()}
                    </div>
                  </div>

                  {/* Raw Image */}
                  <div className="mb-3 row">
                    <label className="col-3 form-label">Raw Image</label>
                    <div className="col">
                      {data?.rawImage ? (
                        <LazyImageComponent
                          src={data.rawImage}
                           height="250px"
                              width="250px"
                          alt="raw"
                        />
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>

                  <hr className="p-2 m-2"></hr>
                  <h2 className="">Final Images</h2>
                  <hr className="p-2 m-2"></hr>

                  {/* Final Images */}
                  <div className="mb-3 row">
                    <label className="col-3 form-label">Final Images</label>
                    <div className="col d-flex flex-wrap gap-3">
                      {data?.images?.length > 0
                        ? data.images.map((img, i) => (
                            <LazyImageComponent
                              key={i}
                              src={img}
                              height="250px"
                              width="250px"
                              alt={`img-${i}`}
                            />
                          ))
                        : "No Images"}
                    </div>
                  </div>
                  <hr className="p-2 m-2"></hr>
                  <h2>Proofs</h2>
                  <hr className="p-2 m-2"></hr>
                  {/* Proofs */}
                  <div className="mb-3 row">
                    <label className="col-3 form-label">Proofs</label>
                    <div className="col d-flex flex-wrap gap-3">
                      {data?.proofs?.length > 0
                        ? data.proofs.map((img, i) => (
                            <LazyImageComponent
                              key={i}
                              src={img}
                              height="250px"
                              width="250px"
                              alt={`proof-${i}`}
                            />
                          ))
                        : "No Proofs Uploaded"}
                    </div>
                  </div>

              

                  {/* Buttons */}
                  <div className="card-footer text-end">
                    <SimpleButton
                      buttonText="Edit Graphics Post"
                      href={`/edit-graphics/${data.id}`}
                    />
                    <SimpleButton
                      buttonText="Back"
                      type="secondary"
                      onClick={() => navigate(-1)}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewGraphics;
